module.exports = __webpack_public_path__ + "img/small-1.4ac0d437.png";